import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';
import logoOuraTrust from '@/assets/logo-ouratrust-v2.png';

interface FullscreenLoaderProps {
  message?: string;
}

export const FullscreenLoader = ({ message }: FullscreenLoaderProps) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-background"
    >
      {/* Logo */}
      <motion.img
        src={logoOuraTrust}
        alt="OuraTrust"
        className="h-12 object-contain mb-8"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.3 }}
      />
      
      {/* Spinner */}
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
      >
        <Loader2 className="w-8 h-8 text-primary animate-spin" />
      </motion.div>
      
      {/* Message */}
      {message && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="mt-4 text-muted-foreground text-sm"
        >
          {message}
        </motion.p>
      )}
    </motion.div>
  );
};
